import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPublishButtonPending } from './selectIsPublishButtonPending';
import { selectIsSaveDraftPending } from '../draft';

export function selectIsSaveDraftButtonDisabled(state: IAppState): boolean {
  const isPublishButtonPending = selectIsPublishButtonPending(state);
  const isSaveDraftPending = selectIsSaveDraftPending(state);

  return isPublishButtonPending || isSaveDraftPending;
}
